import styled from 'styled-components';
import {MAIN_COLOR} from "../../globalThemes";

const SectionHeader = styled.p`
    font-size: 40px;
    font-family: BlenderProBold, serif;
    background: -webkit-linear-gradient(left, #1F1F1F, ${MAIN_COLOR});
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: bold;
    text-align: center;    
`;

export default SectionHeader;
